import React, { forwardRef } from "react";
import Select from "react-select";

export const selectMenuStyles = {
  control: (provided) => ({
    ...provided,
    minWidth: 250,
    height: 46,
    width: "auto",
  }),

  singleValue: (provided) => ({
    ...provided,
    overflow: "visible",
    textOverflow: "clip",
    maxWidth: "none",
  }),

  menuList: (provided) => ({
    ...provided,
    maxHeight: 200,
    overflowY: "auto",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": { width: "4px", height: "4px" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "2px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f1f1",
      borderRadius: "2px",
    },
  }),

  menu: (provided) => ({
    ...provided,
    minWidth: 150,
  }),
};

const Scroller = forwardRef(({
  options = [],
  value = null,
  onChange = () => { },
  placeholder = "Select Option",
  isClearable = true,
  isDisabled = false,
  onInputChange,
  onMenuScrollToBottom,
  onMenuOpen,
  noOptionsMessage,
  isLoading = false,
  formatOptionLabel,
  styles = {}
}, ref) => {
  return (
    <Select
      ref={ref}   // ✅ forward ref to react-select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isLoading={isLoading}
      loadingMessage={() => "Loading..."}
      menuPortalTarget={document.body}
      onInputChange={onInputChange}
      onMenuScrollToBottom={onMenuScrollToBottom}
      onMenuOpen={onMenuOpen}
      filterOption={null}
      styles={{
        ...selectMenuStyles,
        ...styles,
      }}
      noOptionsMessage={noOptionsMessage}
      formatOptionLabel={formatOptionLabel}
    />
  );
});

export default Scroller;